const LOCAL_ART_URLS: Record<string, string> = {
  "event:20000": "/art/events/opening/event-20000.png",
  "event:20300": "/art/events/opening/event-20300.png",
  "event:20301": "/art/events/opening/event-20301.png",
  "event:20302": "/art/events/opening/event-20302.png",
  "event:20303": "/art/events/opening/event-20303.png",
  "event:20304": "/art/events/opening/event-20304.png",
  "event:29999": "/art/events/endings/event-29999.png",
  "event:28000": "/art/events/endings/event-28000.png",
  "event:28001": "/art/events/endings/event-28001.png",
  "event:28002": "/art/events/endings/event-28002.png",
  "event:28003": "/art/events/endings/event-28003.png",
  "event:28004": "/art/events/endings/event-28004.png",
  "event:28005": "/art/events/endings/event-28005.png",
  "event:28006": "/art/events/endings/event-28006.png",
  "event:28007": "/art/events/endings/event-28007.png",
  "event:28010": "/art/events/endings/event-28010.png",
  "event:28011": "/art/events/endings/event-28011.png",
  "event:28012": "/art/events/endings/event-28012.png",
  "event:28013": "/art/events/endings/event-28013.png",
  "event:28014": "/art/events/endings/event-28004.png",
  "event:28015": "/art/events/special/event-28015.png",
  "event:20760": "/art/events/special/event-20760.png",
  "event:20761": "/art/events/special/event-20761.png",
  "event:20762": "/art/events/special/event-20762.png",
  "event:20763": "/art/events/special/event-20763.png",
  "event:20603": "/art/events/special/event-20603.png",
  "event:20770": "/art/events/special/event-20770.png",
  "event:20771": "/art/events/special/event-20771.png",
  "event:20772": "/art/events/special/event-20772.png",
  "event:20773": "/art/events/special/event-20773.png",
  "event:20774": "/art/events/special/event-20774.png",
  "event:20775": "/art/events/special/event-20775.png",
  "event:20776": "/art/events/special/event-20776.png",
  "event:20777": "/art/events/special/event-20777.png",
  "event:20778": "/art/events/special/event-20778.png",
  "event:20779": "/art/events/special/event-20779.png",
  "event:20780": "/art/events/special/event-20780.png",
  "event:20781": "/art/events/special/event-20781.png",
  "event:20782": "/art/events/special/event-20782.png",
  "event:20783": "/art/events/special/event-20783.png",
  "event:20784": "/art/events/special/event-20784.png",
  "event:20785": "/art/events/special/event-20785.png",
  "event:28016": "/art/events/special/event-28016.png",
  "event:28017": "/art/events/special/event-28017.png",

  "item:10000": "/art/items/opening/item-10000.png",
  "item:10300": "/art/items/opening/item-10300.png",
  "item:10301": "/art/items/opening/item-10301.png",
  "item:10302": "/art/items/opening/item-10302.png",
  "item:10303": "/art/items/opening/item-10303.png",
  "item:10304": "/art/items/opening/item-10304.png",
  "item:10305": "/art/items/opening/item-10305.png",
  "item:10306": "/art/items/opening/item-10306.png",
  "item:10307": "/art/items/opening/item-10307.png",
  "item:10308": "/art/items/opening/item-10308.png",
  "item:10309": "/art/items/opening/item-10309.png",
  "item:10310": "/art/items/opening/item-10310.png",
  "item:10311": "/art/items/opening/item-10311.png",
  "item:10600": "/art/items/special/item-10600.png",
  "item:10601": "/art/items/special/item-10601.png",
  "item:10602": "/art/items/special/item-10602.png",
  "item:19710": "/art/items/special/item-19710.png",
  "item:19711": "/art/items/special/item-19711.png",
  "item:19712": "/art/items/special/item-19712.png",
  "item:19720": "/art/items/special/item-19720.png",
  "item:19721": "/art/items/special/item-19721.png",
  "item:19722": "/art/items/special/item-19722.png",
  "item:19723": "/art/items/special/item-19723.png",
  "item:19724": "/art/items/special/item-19724.png",
  "item:19725": "/art/items/special/item-19725.png",
  "item:19726": "/art/items/special/item-19726.png",
  "item:19727": "/art/items/special/item-19727.png",
  "item:19728": "/art/items/special/item-19728.png",
  "item:19729": "/art/items/special/item-19729.png",
  "item:19730": "/art/items/special/item-19730.png",
  "item:19731": "/art/items/special/item-19731.png",
};

export function localArtUrl(ref: string | null | undefined): string | null {
  if (!ref) return null;
  return LOCAL_ART_URLS[ref] ?? null;
}
